import { getApiUrlString, setUrlMap } from '../modules/get_apiUrlString'
import { getCode } from '../modules/get_code'
import { modelingTimeString } from '../modules/get_convertStr'

import { buildPlayerDetailDatas, calcAgeString} from './process/modelingPlayerDetailData'
import { createPlayerDetailModalStrings } from './process/createPlayerDetailIframeString'
import createModalString from './process/createModalString'

import countries from '../json/countries.json'

console.log('api_thread_round.js')
const urlMap = {};

onmessage = async function(ev) {
  Object.assign(urlMap, ev.data);
  setUrlMap(urlMap);
  // console.log('urlMap', urlMap);

  // 出走表用のデータ取得
  const runQueryString = `?race_id=${urlMap.queryObject.race_id}`
  const runResultPromise = await fetch(getApiUrlString('runs', runQueryString))
    .then(res => res.json())
    .then(res => res.data)
    .catch(error => {
      postMessage({
        type: 'error',
        data: error
      })
    })
  console.log('runResultPromise', runResultPromise);
  if (!runResultPromise || runResultPromise.race_table.length == 0) {
    postMessage({
      type: 'error',
      data: runResultPromise
    })
    return;
  }
  const { id, promoter_year, season, round_code, event_code } = runResultPromise.hold_daily_schedule;

  const promoterYear2Digit = promoter_year % 1000;
  // ページタイトル用データの生成
  const pageData = {
    year: promoter_year,
    yearTxt: `${promoterYear2Digit}-${promoterYear2Digit + 1}`,
    season,
    roundCode: round_code,
    hasTtResult: true,
    classification: {
      en: getCode('race', runResultPromise.name).en,
      name: getCode('raceDetail', runResultPromise.detail).name
    }
  }

  // migratory レースリンク生成用データ取得と整形
  const raceQueryString = `?hold_daily_schedule_id_list[]=${id}`;
  const raceResultPromise = await fetch(getApiUrlString('race_revision', raceQueryString))
    .then(res => res.json())
    .then(res => res.data[0].race_list)
    .then(res => res.map(raceInfo => {
      console.log({raceInfo})
        return {
          id: raceInfo.id,
          title: getCode('raceDetail', raceInfo.detail).name,
          isCurrent: raceInfo.id == urlMap.queryObject.race_id,
          isRaceComing: raceInfo.race_status == 1,
          isRaceDiscontinuation: raceInfo.cancel_status == 2,
          num: `${raceInfo.race_no}R`
        }
      })
    );
  console.log('raceResultPromise', raceResultPromise);

  // migratory トーナメントリンク生成用データ取得と整形
  const tournamentQueryString = `?promoter_year=${promoter_year}&season=${season}&round_code=${round_code}`;
  const tournamentResultPromise = await fetch(getApiUrlString('tournament', tournamentQueryString))
    .then(res => res.json())
    .then(res => res.data.hold_daily_schedule_list.map(schedule => {
      schedule.isCurrent = (schedule.event_code == event_code);
      schedule.isTournamentDiscontinuation = schedule.hold_schedule_status == 2;
      schedule.date = `${schedule.event_date.split(/-|\./).slice(1).join('月')}日`;
      return schedule;
    }));

  console.log('tournamentResultPromise:',tournamentResultPromise);

  // メインスレッドへの返却用基本データの生成
  const postData = {
    type: 'base',
    page: pageData,
    tournament: tournamentResultPromise,
    race: raceResultPromise,
    run: {},
    runInfo: {}
  };

  postData.page.isClassificationAllRaceDiscontinuation = raceResultPromise.filter(raceInfo => raceInfo.isRaceDiscontinuation).length == raceResultPromise.length;
  postData.page.isClassificationAllRaceComingSoon = raceResultPromise.filter(raceInfo => raceInfo.isRaceComing).length == raceResultPromise.length;

  // 選手のデータ構築と車番による並び替え
  const runTable = (() => {
    const hasOddsNumGroup = runResultPromise.race_table.filter(rowData => !!rowData.odds)
    const noOddsNumGroup = runResultPromise.race_table.filter(rowData => !rowData.odds)

    // odds が存在するメンバーだけで人気順のソート
    hasOddsNumGroup.sort((a, b) => {
      return a.odds - b.odds;
    }).map((rowData, rIdx) => {
      rowData.rate = rowData.odds;
      rowData.odds = (rIdx + 1);
    });

    noOddsNumGroup.forEach(rowData => {
      rowData.rate = rowData.odds;
      rowData.odds = null;
    })

    // 出走登録された選手の詳細データ整形 => 車番による並び替え
    return [...hasOddsNumGroup, ...noOddsNumGroup].map(rowData => {
      const nameJp = rowData.player.last_name_jp && rowData.player.first_name_jp ? `${rowData.player.last_name_jp} ${rowData.player.first_name_jp}` : null;
      const nameEn = rowData.player.last_name_en && rowData.player.first_name_en ? `${rowData.player.last_name_en} ${rowData.player.first_name_en}` : null;
      return {
        bike_no: rowData.bike_no,
        start_position: rowData.start_position,
        cancel: rowData.cancel,
        race_rank: rowData.race_rank,
        race_time: modelingTimeString(rowData.race_time, 2),
        race_difference_code: rowData.race_difference_code,
        odds: rowData.odds,
        rate: rowData.rate,
        player: rowData.player,
        playerId: rowData.player.id,
        name: nameJp || nameEn,
        age: calcAgeString(rowData.player.birthday, ''),
        country : (() => {
          return rowData.player.country_code
            ? countries[rowData.player.country_code].code3.toUpperCase()
            : 'ー';
        })(),
        tt_time: modelingTimeString(rowData.tt_time),
        tt_rank: rowData.tt_rank,
        gear_rate: (() => {
          if (rowData.gear) {
            return `${rowData.gear * 1000}`.slice(0, 1) + '.' + `${rowData.gear * 1000}`.slice(1, 3);
          }
          return null
        })(),
        ratio: (() => {
          if (rowData.winner_rate || rowData['2quinella_rate'] || rowData['3quinella_rate']) {
            return [
              `<span class="le-round-odds__ratio-txt">${rowData.winner_rate || '-'}%</span>`,
              `<span class="le-round-odds__ratio-txt">${rowData['2quinella_rate'] || '-'}%</span>`,
              `<span class="le-round-odds__ratio-txt">${rowData['3quinella_rate'] || '-'}%</span>`,
            ].join('<br>');
          }
          return null;
        })(),
        past_result: (() => {
          if (rowData.last_round_result) {
            const resultInfo = rowData.last_round_result;
            const roundHoldLink = `/league/player/?year=${resultInfo.promoter_year}&season=${resultInfo.season}&round_code=${resultInfo.round_code}`;
            const roundDate = resultInfo.event_date.replace(/-/g, '/');
            const roundTtRecord = (resultInfo.tt_record+'000').slice(0, 6);
            const raceOrderTxt = resultInfo.race_list.map(race => {
                return /[1-6]/.test(race.race_rank)
                  ? race.race_rank
                  : `<b>${race.race_rank}</b>`;
              }).join('-');
            return [
              `<a class="le-round-odds__result-date" href="${roundHoldLink}">${roundDate}</a>`,
              `<span class="le-round-odds__result-tt">${roundTtRecord}</span>`,
              `<span class="le-round-odds__result-order">${raceOrderTxt}</span>`
            ].join('<br>');
          }
          return 'ー'
        })()
      }
    }).sort((a, b) => {
      return a.bike_no - b.bike_no;
    });
  })()

  // スタートポジション表示のためのデータ成形
  const runStart = (() => {
    // スタート位置のデータを持っている出走選手データのみをフィルタリング
    const hasStartPosRowData = runTable.filter(rowData => rowData.start_position);
    // 抽出データの個数と出走選手データの個数があった場合のみ、ソート→車番抽出
    if (hasStartPosRowData.length == runTable.length) {
      return hasStartPosRowData
        .sort((a, b) => a.start_position - b.start_position)
        .map(rowData => rowData.bike_no);
    }
    // データに整合性がないため空配列を返す（html操作では空配列はスタートポジション表示の全てを削除とする）
    return []
  })();
  console.log('runStart', runStart);

  postData.run = {
    runTable,
    noteText: runResultPromise.free_text || null,
    runStart
  }
  postData.runInfo = convertDateInfo(runResultPromise.hold_daily_schedule);
  // 出走時間の追加
  postData.runInfo.start = runResultPromise.post_time;
  // レース開催可否の追加
  postData.runInfo.isRunDiscontinuation = runResultPromise.cancel_status == 2;

  // console.log(runResultPromise);

  // レース結果のデータ成形
  postData.result = (() => {
    const refundMap = {};

    // レース終了用のデータ構築（動画）
    const existVideoData = (() => {
      return runResultPromise.race_movie_yt_id || runResultPromise.interview_movie_yt_id
    })();
    if (existVideoData) {
      refundMap.movie = {
        race: [runResultPromise.race_movie_yt_id].filter(movieId => movieId),
        interview: [runResultPromise.interview_movie_yt_id].filter(movieId => movieId),
      };
    }

    // レース終了用のデータ構築（順位）
    const existOrderData = (() => {
      return runTable.filter(rowData => rowData.race_rank != null).length == runTable.length;
    })();
    console.log({existOrderData})
    if (existOrderData) {
      // レース結果順位による並び替え
      const refundRunData = (() => {
        const refundPlayers = runTable.map(rowData => rowData);
        const completedPlayers = refundPlayers.filter(player => player.race_rank)
          .sort((a, b) => {
            return a.race_rank - b.race_rank;
          });
        // race_rank == null : レース結果データ反映前：レース結果未確定（払戻金のデータだけが先に挿入されて、結果データ（順位など）は未挿入のため）
        // race_rank == 0 : レース結果データ反映後：レース結果確定（全てのデータ（順位、タイム、着差）が挿入されている状態、棄権・失格の区別がないためハイフン表示に統一、テキストによる内容表示はなし）
        const disqualificationPlayer = refundPlayers.filter(player => player.race_rank == 0);

        return [...completedPlayers, ...disqualificationPlayer];
      })();

      refundMap.order = {
        orderNum: refundRunData,
        noteText: runResultPromise.free_text ? runResultPromise.free_text : null
      }
    }

    // レース終了用のデータ構築（払戻金）
    const existPaymentData = (() => {
      return runResultPromise.payoff_list && runResultPromise.payoff_list.length > 0;
    })();
    if (existPaymentData) {
      // 払戻金のデータ成形
      const refundPaymentData = {
        result: {},
        notes: {
          isSpecial: false,
          isReturn: false
        }
      };
      // 投票タイプによるグルーピング
      // 特払い・返還の検知 => テーブル下に表示するnote表示用
      const paymentGroup = {};
      runResultPromise.payoff_list.forEach(payoffData => {
        if (!paymentGroup[payoffData.vote_type]) {
          paymentGroup[payoffData.vote_type] = []
        }
        if ([20, 30, 31, 32].includes(payoffData.payoff_type)) {
          const key = payoffData.payoff_type == 20
            ? "isSpecial"
            : "isReturn";
          refundPaymentData.notes[key] = true;
        }
        paymentGroup[payoffData.vote_type].push(payoffData);
      });
      // 払戻金テーブル表示用テキスト生成
      const paymentResult = refundPaymentData.result;
      [10, 30, 31, 50, 51, 60].forEach(voteTypeKey => {
        paymentResult[voteTypeKey] = (() => {
          // APIからのグルーピング済み返却データによる払戻金テキスト生成
          if (paymentGroup[voteTypeKey]) {
            // 表示データのフィルタリング
            // 通常の配当金払い戻しのみ抽出
            const availableData = paymentGroup[voteTypeKey].filter(payoffData => ![20, 30, 31, 32].includes(payoffData.payoff_type));
            const orderText = availableData.length == 0
              ? 'ー'
              : availableData.map(payoffData => convertRefundOrderText(payoffData)).join('<br>');
            // 払戻金は
            //  通常：データ通り表示
            //  特払い：70で統一されているので、paymentGroupの先頭データから金額抽出
            //  返還：特に表示せず
            const refundText = availableData.length == 0
              ? (() => {
                  const payoffType = paymentGroup[voteTypeKey][0].payoff_type;
                  if ([20, 30, 31, 32].includes(payoffType)) {
                    return convertRefundPayText(paymentGroup[voteTypeKey][0]);
                  }
                  return 'ー';
                })()
              : availableData.map(payoffData => convertRefundPayText(payoffData)).join('<br>');
            return {
              order: orderText,
              refund: refundText
            }
          } else {
            return {
              order: 'ー',
              refund: 'ー'
            }
          }
        })();
      });
      // console.log(paymentResult);

      refundMap.payment = refundPaymentData;
    }

    console.log({refundMap});

    return Object.keys(refundMap).length > 0
      ? refundMap
      : null;
  })()

  // SPの際は選手モーダルを開く為
  // PC時は別タブで選手詳細ページが開かれる
  if (urlMap.isSp) {
    // カード裏面用選手データのメインスレッドへの返却
    const playerList = runTable.map(row => row.player);
    const playerDetailDatas = buildPlayerDetailDatas(playerList);
    const modalPlayerString = await createPlayerDetailModalStrings(playerDetailDatas)
    const modalString = await createModalString(modalPlayerString);
    postMessage({
      type: 'playerDetail',
      modalString: modalString
    });
  }

  // メインスレッドへのデータ返却
  postMessage(postData);
}

// レース詳細データの構築
const convertDateInfo = (dateInfo)  => {
  const dateObj = new Date(dateInfo.event_date);
  const weekMap = [
    '日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日'
  ]
  return Object.assign({
    cls: dateInfo.day_night == 0 ? '_day' : '_night',
    zone: dateInfo.day_night == 0 ? 'デイ' : 'ナイト',
    date: dateInfo.event_date.split('-').slice(1).join('.'),
    week: weekMap[dateObj.getDay()]
  }, dateInfo)
}

// 払戻金の車順テキストの生成
const convertRefundOrderText = (payoffData) => {
  // 車番をつなぐセパレーターの生成
  const separetor = (() => {
    if ([10, 20].includes(payoffData.vote_type)) {
      return '';
    } else if ([30, 40, 50].includes(payoffData.vote_type)) {
      return ' - '
    } else if ([31, 41, 51, 60].includes(payoffData.vote_type)) {
      return ' = '
    }
    return ' ';
  })();

  // 車順テキストの構築
  return ['tip1', 'tip2', 'tip3'].map(key => payoffData[key])
    .filter(num => num)
    .join(separetor);
}
// 払戻金の金額テキストの生成
const convertRefundPayText = (payoffData) => {
  const currencyText = '<span class="le-refund__currency">円</span>';

  // 金額テキストの構築
  return `${payoffData.payoff}${currencyText}`;
}
